
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "536af52cfd65170d8b16abe7ec06b22310b15084",
  "nuxt": {
    "buildId": "7c50ea4d-e5bd-4af7-8e67-32cbd65c8888"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
